import { ISmartStorageProviderV2, StorageProvider } from '../support/StorageProvider.ts';

export interface ISavedState {
    enjoyFirstMissionShown?: string;
}

export class FeedbackAlertStorage {
    static inject = () => [StorageProvider];
    constructor(storage: StorageProvider){
        this.feedbackAlerts = storage.getJSONProvider<ISavedState>('ap:feedback-alerts', { storageType: 'localStorage' });
    }

    feedbackAlerts: ISmartStorageProviderV2<ISavedState>;
}
